
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../../services/home.service';

import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
import { ClientService } from '../../../../services/clients';
import { get } from 'http';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

@Component({
  selector: 'app-myclientspage',
  templateUrl: './myclientspage.component.html',
  styleUrl: './myclientspage.component.scss'
})
export class MyclientspageComponent {

  @Input() isProfile: string = "";

  allData: any[] = [];
  userimage!: string;
  userData!: users;
  username!: string;
  userPhone: string = '';
  userName: string = '';
  profile!: boolean;
  userfirstname: string = '';
  userFacebook: string = '';
  userInstgram: string = '';
  userTiktok: string = '';

  displayedColumns: string[] = [
    localStorage.getItem("language") == "ar" ? 'name_ar' : 'name_en',
    'job',
    'address',
    'phone_number',
    'internet_date',
    'numbers',
    'foreign_agency',
    "checks",
    'worker_embassy',
    "visatype",
    "representative",
    'call',
    'chat',
    'options'
  ];

  contentReady: boolean = true;
  noData: boolean = false;
  showPopUp: boolean = false;
  showRejectPopUp: boolean = false;
  orderchange!: FormGroup;
  reason: string = "";
  orderId!: any;
  statuslist: any;
  clear: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  stockTotal!: any;
  totalItems!: any;
  searched: boolean = false;
  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '1')
  );
  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '6')
  );
  showoptions: boolean = false;
  searchKey: string = '';
  isAr: boolean = localStorage.getItem("language") == "ar";
  dataSource: MatTableDataSource<any>;
  isMobile: boolean = false;
selectedVisaType: number = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private router: Router,
    private _clientsService: ClientsService,
    private _clients: ClientService,
    private deviceService: DeviceDetectorService,
    private _profileService: ProfileService,
    private excelExportService: ExcelExportService,
    private _userService: UserService,
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isAdmin$.subscribe(value => console.log('isAdmin:', value));
    this.isMobile = this.deviceService.isMobileDevice();
    if (this.isMobile) {
      this.displayedColumns = [
        'name_ar',
        'phone_number',
      ];
    }
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
        this.isSubAdmin = this.accountType == "6";
        if (this.accountType == "1" || this.accountType == "2") {

          if (!this.isMobile) { // هات آخر عنصر
            const last = this.displayedColumns.pop();

            // ضيف العمود الجديد
            this.displayedColumns.push("payment");

            // رجّع آخر عنصر
            if (last) {
              this.displayedColumns.push(last);
            }
          }
        }
        if (!data['has_access_to_phone_numbers']) {

          const colsToRemove = ['phone_number', 'call', 'chat'];
          this.displayedColumns = this.displayedColumns.filter(col => !colsToRemove.includes(col));
        }
             else{

            this.displayedColumns.push('add_by');
            this.displayedColumns.push('editor');
        }
        this.getAllClients(10, 1);

      },
      error: (error) => console.error(error),
    });


  }
  onVisaTypeChange(event: Event) {
  const selectElement = event.target as HTMLSelectElement; // ⬅️ Type cast
  this.selectedVisaType = Number(selectElement.value);

  this.getClientsByVisaType(this.selectedVisaType, 10, 1);
}
  getClientsByVisaType(visaType: number, perpage: number, page: number) {
  this.contentReady = true;
  this._clients.getByVisaType(visaType, perpage, page).subscribe({
    next: (data) => {
      this.allData = data['data'];
      this.stockTotal = data['last_page'];
      this.totalItems = data['total'];
      this.dataSource = new MatTableDataSource(this.allData);
      this.contentReady = false;
      this.noData = this.allData.length === 0;
    },
    error: (error) => {
      console.error('Error fetching clients by visa type:', error);
      this.contentReady = false;
    }
  });
}

    formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);
    return `${day}-${month}-${year}`;
  }
  search() {
    if (this.searchKey != null && this.searchKey != undefined && this.searchKey != "") {
      this.contentReady = true;
      this._clients.searchClients(this.searchKey).subscribe({
        next: (data) => {

          this.allData = data;
          this.dataSource = new MatTableDataSource(this.allData);
          this.contentReady = false;
          if (this.allData.length === 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        },
        error: (error) => console.error(error),
      });
    }

  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('Clients', 'AhmedElshahatClients', ['actions']);
  }
  delete(id: any) {
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._clients.delete(id).subscribe({
          next: (res) => {
            this.getAllClients(10, 1);
          },
          error: (err) => console.log(err),
        });
      }
    });


  }
  edit(itemobj: any) {
    this.router.navigate(['/createclient'], { queryParams: itemobj });
  }
  getAllClients(perpage: any, page: any) {
    this.contentReady = true;
    this.searched = false;
    this._clients.getAll(perpage, page).subscribe({
      next: (data) => {
       let all = data['data'];
        this.allData = all;

        this.stockTotal = data['last_page'];
        this.totalItems = data['total'];

        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
onPaginateChange(event: PageEvent) {
  const newPage = event.pageIndex + 1;
  if (this.searched) {
    this.search();
  } else if (this.selectedVisaType !== undefined) {
    this.getClientsByVisaType(this.selectedVisaType, 10, newPage);
  } else {
    this.getAllClients(10, newPage);
  }
}

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  call(phone: any) {
    window.open("tel:+" + phone, '_blank');
  }
  chat(phone: any) {
    // href="https://api.whatsapp.com/send?phone=201012673672"

    window.open("https://api.whatsapp.com/send?phone=2" + phone, '_blank');
  }
  changeClientStatus(id: number, status: number) {
    this._clients.updateStatus(id, status).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل حالة العميل" : 'Client status updated',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getAllClients(10, 1);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل تعديل حالة العميل" : 'Client status not updated',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      }
    });
  }
}